<template>
  <svg width="12" height="12" viewBox="0 0 12 12" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path d="M11.9195 2.94537L9.51965 0.132873C9.36889 -0.044291 9.03063 -0.044291 8.87986 0.132873L6.48006 2.94537C6.28005 3.17928 6.47702 3.51007 6.79996 3.51007H7.99986V5.64715C7.99986 5.7649 7.93344 5.87442 7.82174 5.93965L6.00002 7.00704L4.17297 5.93965C4.06125 5.87442 3.99485 5.7649 3.99485 5.64715V3.51007H5.20009C5.52331 3.51007 5.71978 3.17902 5.51998 2.94537L3.12018 0.132873C2.96942 -0.044291 2.63115 -0.044291 2.48039 0.132873L0.0805907 2.94537C-0.119419 3.17928 0.0775509 3.51007 0.400484 3.51007H1.60039V6.02344C1.60039 6.57345 1.89919 7.09941 2.40032 7.42969L4.64037 8.90632C4.74037 8.97223 4.80012 9.0773 4.80012 9.1875V11.6484C4.80012 11.8428 4.97901 12 5.20009 12H6.79996C7.02103 12 7.19459 11.8428 7.19462 11.6484V9.1875C7.19462 9.0773 7.25437 8.97225 7.35436 8.90632L9.60012 7.42969C10.1009 7.09941 10.3943 6.57345 10.3943 6.02344V3.51007H11.5996C11.9228 3.51007 12.1193 3.17902 11.9195 2.94537Z"/>
  </svg>
</template>

<script>
export default {
name: "IconSplit"
}
</script>

<style scoped>

</style>